import { FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const Subtitle = styled(FuelTypography).attrs({ size: 'body-sm', color: 'neutral-default', weight: 'medium' })`
  p {
    padding-top: 8px;
    padding-bottom: 32px;
  }
`

export const Title = styled(FuelTypography).attrs({ size: 'heading-sm', color: 'neutral-strong', weight: 'bold' })`
  p {
    padding-top: 16px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
